import gql from 'graphql-tag'

export default gql`
mutation deleteOfferGroup($groupIndex: Int!) {
	cashAssist {
		deleteOfferGroup(groupIndex: $groupIndex) {
			productActionGroups
		}
	}
}`
